// i18n area 'hci' — locale lt-LT (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.lt-LT.meta.json.
import type { enUS } from './hci'

export const ltLT: typeof enUS = {
  hci: {
    ceph: {
      title: 'Ceph klasteriai',
      createButton: 'Kurti Ceph klasterį',
      emptyTitle: 'Valdomų Ceph klasterių nėra',
      emptyBody: 'TVirt įdiegia ir valdo Ceph mazguose nariuose — hiperkonvergentiškai kartu su VM krūviu. Sukurkite klasterį: pirmasis monitorius ir jo valdiklis automatiškai gimsta pasirinktame valdymo mazge — paskui auginkite jį kitais monitoriais ir OSD įrenginiais.',
      pageTitle: 'Ceph klasteriai',
      colState: 'Būsena',
      colMembers: 'Nariai',
      colSize: 'Dydis',
      colVersion: 'Ceph versija',
      sizeCell: 'panaudota {used} GiB iš {total} GiB',
      phase: {
        'not-deployed': 'Neįdiegtas',
        deploying: 'Diegiamas',
        healthy: 'Sveikas',
        degraded: 'Degradavęs',
        error: 'Klaida',
        destroying: 'Naikinamas',
        destroyed: 'Sunaikintas'
      },
      health: {
        HEALTH_OK: 'Sveikas (HEALTH_OK)',
        HEALTH_WARN: 'Su įspėjimais (HEALTH_WARN)',
        HEALTH_ERR: 'Klaidos būsenoje (HEALTH_ERR)',
        unknown: 'Dar nestebėta',
        observedAt: 'stebėta {time}'
      },
      create: {
        title: 'Kurti Ceph klasterį',
        info: 'Kuriant naują Ceph klasterį reikia pasirinkti pirmąjį mazgą, kuriame bus įdiegti MON ir MGR vaidmenys. Taip pat reikia nurodyti, kurį potinklį naudoti Ceph srautui: public potinklis naudojamas bendram tinklo srautui, o cluster potinklis — vidinėms replikoms tarp OSD; skirtingi potinkliai nėra būtini.',
        controlNode: 'Valdymo mazgas',
        controlNodeHint: 'Mazgas narys, kuriame gimsta pirmasis MON + MGR.',
        publicSubnet: 'Public potinklis',
        publicSubnetHint: 'IPAM registre užregistruotas potinklis — Ceph public_network. Sukūrus nebekeičiamas.',
        clusterSubnet: 'Cluster potinklis',
        clusterSubnetHint: 'IPAM registre užregistruotas potinklis — Ceph cluster_network (replikavimas ir backfill).',
        noSubnets: 'Užregistruotų potinklių nėra — pirma sukurkite juos IPAM registre',
        sameSubnet: 'Tas pats potinklis public ir cluster srautui',
        sameSubnetHint: 'Pažymėta = cluster tinklas (replikavimas ir backfill) sutampa su public. Nepažymėta = pasirinkite jo potinklį IR valdymo mazgo adresą jame.',
        controlAddress: 'Valdymo mazgo adresas',
        controlAddressHint: 'Adresas, kurį IPAM žino šiam mazgui public potinklyje.',
        controlClusterAddress: 'Valdymo mazgo cluster adresas',
        controlClusterAddressHint: 'Adresas, kurį IPAM žino šiam mazgui cluster potinklyje.',
        noAddresses: 'IPAM nežino nė vieno šio mazgo adreso pasirinktame potinklyje',
        started: 'Klasteris sukurtas — bootstrap tęsiamas kaip makrotask; fazė atsinaujins pati',
        error: 'Klasteris buvo atmestas'
      },
      detail: {
        actions: 'Galimi veiksmai',
        tabOverview: 'Apžvalga',
        tabManagementNodes: 'MON ir MGR',
        tabDisks: 'OSD',
        tabPools: 'Telkiniai',
        tabObjects: 'Objektai',
        tabCrush: 'CRUSH žemėlapis',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Išplėstinės',
        phase: 'Fazė',
        checksTitle: 'Aktyvūs būklės patikrinimai',
        noChecks: 'Aktyvių būklės patikrinimų nėra',
        checkMuted: 'nutildyta',
        summaryPools: 'Telkiniai',
        summaryFilesystems: 'Failų sistemos',
        nodesCard: 'Mazgai',
        monHint: 'Kartu su kiekvienu MON veikia ir MGR. Trys MON yra rekomenduojamas kvorumas; laboratorinis klasteris pradeda nuo vieno. OSD ir MDS gyvena savo kortelėse.',
        monHintSplit: 'Šiame klasteryje MON ir MGR yra atskirti (Išplėstinės): kiekvienas vaidmuo turi savo narystę kiekviename mazge. Trys MON yra rekomenduojamas kvorumas; turi būti bent vienas MGR.',
        noMons: 'Nedeklaruotas nė vienas monitorius',
        addNode: 'Pridėti mazgą',
        removeNode: 'Šalinti mazgą',
        removeNodeFrom: 'Šalinti mazgą {node} (jo MON ir kartu veikiantį MGR)',
        roleMon: 'MON vaidmuo',
        roleMgr: 'MGR vaidmuo',
        roleNa: 'N/A',
        roleNotObserved: 'dar nestebėtas',
        monInQuorum: 'kvorume',
        monOutQuorum: 'už kvorumo ribų',
        mgrActive: 'aktyvus',
        mgrStandby: 'budintis',
        addRoleMon: 'Pridėti MON vaidmenį',
        removeRoleMon: 'Šalinti MON vaidmenį',
        addRoleMgr: 'Pridėti MGR vaidmenį',
        removeRoleMgr: 'Šalinti MGR vaidmenį',
        restartMon: 'Iš naujo paleisti MON paslaugą',
        restartMgr: 'Iš naujo paleisti MGR paslaugą',
        addMon: 'Pridėti MON',
        removeMon: 'Šalinti MON',
        removeMonFrom: 'Šalinti MON vaidmenį iš {node}',
        addMgr: 'Pridėti MGR',
        removeMgr: 'Šalinti MGR',
        removeMgrFrom: 'Šalinti MGR vaidmenį iš {node}',
        addMds: 'Pridėti MDS',
        removeMds: 'Šalinti MDS',
        removeMdsFrom: 'Šalinti MDS vaidmenį iš {node}',
        mdsSection: 'Metaduomenų serveriai (MDS)',
        noMds: 'Nedeklaruotas nė vienas MDS — failų sistemai pirma jo reikia',
        mdsHint: 'MDS narystė nuo pirmos dienos yra atskira: klasteris be CephFS jų nedeklaruoja, o vienas aktyvus ir vienas budintis gerai aptarnauja failų sistemą. Ceph pats išrenka aktyvius ir budinčius iš deklaruotų demonų.',
        mdsActiveFor: 'aktyvus — {fs}',
        mdsNotObserved: 'dar nestebėtas',
        lastMdsGuard: 'Paskutinio MDS pašalinti negalima, kol yra bent viena failų sistema — pirma pašalinkite failų sistemas',
        lastMonGuard: 'Paskutinio MON pašalinti negalima — vienintelė išeitis yra sunaikinti klasterį',
        lastMgrGuard: 'Paskutinio MGR pašalinti negalima — valdomas klasteris niekada neveikia be valdiklio',
        registerDevice: 'Pridėti OSD',
        unregisterDevice: 'Išregistruoti',
        activeDeviceGuard: 'Aktyvus OSD — jis pasitraukia per OSD gyvavimo ciklą, ne iš registro',
        colNode: 'Mazgas',
        devicePhase: { registered: 'Užregistruotas', active: 'Aktyvus' },
        health: 'Būklė',
        state: 'Būsena',
        fsid: 'fsid',
        fsidPending: 'nėra — pakartokite bootstrap',
        version: 'Ceph versija',
        publicNetwork: 'Public tinklas',
        clusterNetwork: 'Cluster tinklas',
        clusterNetworkCollapsed: '= public',
        noActions: 'Šioje fazėje veiksmų nėra',
        destroyedNote: 'Klasteris sunaikintas — eilutė netrukus bus pašalinta automatiškai'
      },
      overview: {
        services: 'Paslaugos',
        ok: 'sveikos',
        warning: 'įspėjimai',
        down: 'neveikia',
        pgTitle: 'PG būsenos',
        pgTotal: 'iš viso PG: {n}',
        capacityTitle: 'Vieta',
        ioTitle: 'Dabartinis I/O',
        ioReadBw: 'Skaitymo pralaidumas',
        ioWriteBw: 'Rašymo pralaidumas',
        ioReadIops: 'Skaitymo IOPS',
        ioWriteIops: 'Rašymo IOPS',
        notObserved: 'dar nestebėta'
      },
      osd: {
        colId: 'ID',
        colClass: 'Device class',
        colState: 'Būsena',
        colSize: 'Dydis',
        colPgs: 'PG',
        empty: 'OSD nėra — pridėkite vieną iš deklaruoto duomenų disko',
        markIn: 'Žymėti IN',
        markOut: 'Žymėti OUT',
        scrub: 'Atlikti scrub',
        deepScrub: 'Atlikti gilų scrub',
        restart: 'Paleisti paslaugą iš naujo',
        details: 'Išsamiau',
        actionGuard: 'Tik aktyviam įdiegto klasterio OSD',
        inTitle: 'Žymėti OSD IN',
        inBody: 'osd.{id} grįžta į duomenų paskirstymą (ceph osd in): Ceph perbalansuoja duomenis į jį.',
        outTitle: 'Žymėti OSD OUT',
        outBody: 'osd.{id} pasitraukia iš duomenų paskirstymo (ceph osd out): jo duomenys perbalansuojami kitur, o perteklius yra SUMAŽĖJĘS, kol vyksta backfill. Bet kada atšaukiama veiksmu Žymėti IN.',
        scrubTitle: 'Suplanuoti scrub',
        scrubBody: 'Suplanuojamas osd.{id} scrub: mon įtraukia jį į eilę, o rezultatą papasakoja tolesnių nuskaitymų PG būsenos.',
        deepScrubTitle: 'Suplanuoti gilų scrub',
        deepScrubBody: 'Suplanuojamas gilus osd.{id} scrub: tai variantas, tikrinantis baitus — sunkesnis I/O atžvilgiu, mechanika ta pati.',
        restartTitle: 'Iš naujo paleisti OSD paslaugą',
        restartBody: 'osd.{id} sustabdomas ir paleidžiamas iš naujo per jo mazge veikiančio worker priežiūrą.',
        started: 'Veiksmas pradėtas — stebėjimo duomenys atsinaujins patys',
        error: 'OSD veiksmas buvo atmestas'
      },
      osdDetail: {
        title: 'OSD detalės',
        tabGeneral: 'Bendra',
        tabNetwork: 'Tinklas',
        tabDevices: 'Įrenginiai',
        version: 'Versija',
        hostname: 'Hostname',
        dataPath: 'OSD duomenų kelias',
        objectStore: 'OSD object store',
        encrypted: 'Užšifruotas',
        yes: 'Taip',
        no: 'Ne',
        memory: 'Atminties naudojimas (PSS)',
        pid: 'Proceso ID (PID)',
        front: 'Front adresas (klientai ir monitoriai)',
        hbFront: 'Heartbeat front adresas',
        back: 'Back adresas (OSD)',
        hbBack: 'Heartbeat back adresas',
        colDevice: 'Įrenginys',
        colType: 'Tipas',
        colPhysical: 'Fizinis įrenginys',
        colSize: 'Dydis',
        volumeTitle: 'Tomo detalės',
        creationTime: 'Sukūrimo data',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Šiam OSD nestebėta nė vieno įrenginio'
      },
      restart: {
        title: 'Paleisti paslaugą iš naujo',
        monBody: 'MON demonas mazge {node} sustabdomas ir paleidžiamas iš naujo per worker priežiūrą.',
        mgrBody: 'MGR demonas mazge {node} sustabdomas ir paleidžiamas iš naujo per worker priežiūrą.',
        started: 'Paleidimas iš naujo pradėtas — stebėjimo duomenys atsinaujins patys',
        error: 'Paleidimas iš naujo buvo atmestas'
      },
      encryptionMode: {
        alwaysOn: 'Visada įjungtas (dmcrypt)',
        alwaysOff: 'Visada išjungtas',
        perOsd: 'Pasirenkama kiekvienam OSD',
        section: 'OSD šifravimas at rest',
        title: 'Keisti OSD šifravimo režimą',
        hint: 'Kaip ruošiami NAUJI OSD. Esami OSD išlaiko savo būseną kiekviename diske: norint ją pakeisti, OSD pašalinamas ir sukuriamas iš naujo.',
        body: 'Režimas tampa „{mode}“ ir galioja TIK NAUJIEMS OSD: kiekvienas esamas OSD išlaiko dabartinę savo šifravimo būseną.',
        apply: 'Keisti režimą',
        error: 'Režimo keitimas buvo atmestas'
      },
      pin: {
        address: 'Public adresas (nebūtinas prisegimas)',
        clusterAddress: 'Cluster adresas (nebūtinas prisegimas)',
        autoPlaceholder: 'automatiškai potinklyje {cidr}',
        hint: 'Adresavimas kiekvienam demonui atskirai: tuščia = Ceph pats prisiriša deklaruotame tinkle; užpildyta = šis egzempliorius prisegamas prie adreso savo konfigūracijos skiltyje.'
      },
      addMon: {
        title: 'Pridėti mazgą',
        node: 'Mazgas',
        address: 'Public adresas',
        addressHint: 'Mazgo adresai, kuriuos IPAM žino public potinklyje — automatiškai, kai mazgą dengia esama deklaracija.',
        clusterAddress: 'Cluster adresas',
        clusterAddressHint: 'Privaloma: cluster potinklis yra atskiras, o mazgas jame dar nedeklaruotas.',
        noAddresses: 'IPAM nežino nė vieno šio mazgo adreso šiame potinklyje',
        error: 'MON pridėjimas buvo atmestas'
      },
      removeMon: {
        title: 'Šalinti MON',
        body: 'MON ir kartu su juo veikiantis MGR palieka mazgą {node}. Įdiegtame klasteryje demonai sustabdomi ir pašalinami iš kvorumo.',
        error: 'MON šalinimas buvo atmestas'
      },
      addMgr: {
        title: 'Pridėti MGR',
        node: 'Mazgas',
        hint: 'Išplėstinės (atskirti MON ir MGR): atskiras valdiklis gimsta pasirinktame mazge naryje su mazgui pririštu task. Ceph active/standby rinkimai patys parenka aktyvų MGR.',
        error: 'MGR pridėjimas buvo atmestas'
      },
      removeMgr: {
        title: 'Šalinti MGR',
        body: 'Atskiras MGR palieka mazgą {node}. Įdiegtame klasteryje demonas sustabdomas, o jo būsena pašalinama; mazgo MON (jei toks yra) neliečiamas.',
        error: 'MGR šalinimas buvo atmestas'
      },
      addMds: {
        title: 'Pridėti MDS',
        node: 'Mazgas',
        hint: 'CephFS metaduomenų serveris: gimsta pasirinktame mazge naryje su mazgui pririštu task, prižiūrimas worker kaip MON ir MGR. Ceph pats išrenka aktyvius ir budinčius — vienas aktyvus ir vienas budintis gerai aptarnauja failų sistemą.',
        error: 'MDS pridėjimas buvo atmestas'
      },
      removeMds: {
        title: 'Šalinti MDS',
        body: 'MDS palieka mazgą {node}. Įdiegtame klasteryje demonas sustabdomas, o jo būsena pašalinama; API atmeta paskutinį MDS, kol jo reikia kuriai nors failų sistemai.',
        error: 'MDS šalinimas buvo atmestas'
      },
      split: {
        title: 'Atskirti MON ir MGR',
        label: 'Leisti MON ir MGR skirtinguose mazguose',
        hint: 'Išjungta (numatytoji) = ratifikuotas standartas: kartu su kiekvienu MON veikia MGR, viena narystė. Įjungta = MGR narystė tampa atskira, tvarkoma veiksmais Pridėti / Šalinti MGR kortelėje Valdymo mazgai.',
        enable: 'Įjungti',
        disable: 'Išjungti',
        enableBody: 'MGR narystė tampa nepriklausoma nuo MON ir inicijuojama pagal dabartinį jų sugyvenimą. Veiksmai Pridėti / Šalinti MGR suaktyvėja kortelėje Valdymo mazgai. Tai atlaisvina platformos numatytąjį elgesį — palikite tai tik tada, jei žinote, kam jums to reikia.',
        disableBody: 'Grįžtama prie standartinio sugyvenimo: po MGR su kiekvienu MON, viena narystė. Teisėta tik tada, jei MGR narystė jau sutampa su MON — pirma suderinkite ją veiksmais Pridėti / Šalinti MGR, kitaip API atmes.',
        error: 'Pakeitimas buvo atmestas'
      },
      rawEditor: {
        title: 'Neapdorotas CRUSH redaktorius',
        label: 'Rodyti neapdorotą crushmap redaktorių kortelėje CRUSH',
        hint: 'Išjungta (numatytoji) = standartinis įrankis yra vedamas taisyklių paviršius. Įjungta = kortelėje CRUSH papildomai rodoma dekompiliuota crushmap kaip redaguojamas tekstas. Įrašant visada reikia sudo ir klasterio pavadinimo patvirtinimui, o tekstas eina per crushtool kompiliavimą ir bandymą PRIEŠ pasiekdamas klasterį.'
      },
      osdFlags: {
        section: 'Visuotinės OSD vėliavėlės',
        title: 'OSD vėliavėlių keitimas rankiniu būdu',
        notObserved: 'dar nestebėtos',
        standardFlowsHint: 'Įprastais atvejais standartiniai platformos srautai šias vėliavėles tvarko patys (mazgo priežiūra nustato tikslinį noout, disko keitimas eina per OSD gyvavimo ciklą). Ši skiltis yra rankinis valdymas operatoriui, kuris žino, ką daro.',
        notDeployedGuard: 'OSD vėliavėlės egzistuoja tik įdiegtame klasteryje',
        set: 'Nustatyti vėliavėlę',
        unset: 'Šalinti vėliavėlę',
        setBody: 'Visuotinė vėliavėlė {flag} bus NUSTATYTA osdmap žemėlapyje. Ji lieka tol, kol nebus aiškiai pašalinta — pamiršta vėliavėlė silpnina klasterio savaiminį gijimą.',
        unsetBody: 'Visuotinė vėliavėlė {flag} bus PAŠALINTA iš osdmap.',
        error: 'Vėliavėlės keitimas buvo atmestas',
        flag: {
          noout: 'Nė vienas OSD nežymimas out iš duomenų paskirstymo — praradus demoną duomenys neperbalansuojami',
          norebalance: 'Duomenų perbalansavimas sustabdytas',
          nobackfill: 'Backfill sustabdytas',
          norecover: 'Atkūrimas sustabdytas',
          pause: 'VISAS klientų I/O pristabdytas (skaitymas ir rašymas)',
          noin: 'Startuojantys OSD nėra automatiškai žymimi in',
          nodown: 'Nepasiekiami OSD nežymimi down — tai užmaskuoja tikrus gedimus'
        }
      },
      pools: {
        section: 'Telkiniai',
        create: 'Kurti telkinį',
        createGuard: 'Telkiniai egzistuoja tik įdiegtame klasteryje',
        notObserved: 'Telkinių stebėjimo duomenų nėra — MON nuskaitymas praneš čia',
        empty: 'Klasteryje telkinių nėra',
        colName: 'Pavadinimas',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Application',
        colRule: 'CRUSH taisyklė',
        colUsage: 'Užimtumas',
        observedAtLabel: 'Stebėta',
        objects: 'objektų: {n}',
        inUseBy: 'naudoja {name}',
        internalGuard: 'Vidinis Ceph telkinys — platforma jo niekada netrina',
        delete: 'Ištrinti telkinį',
        deleteGuard: 'Naudoja storage {name} — pirma ištrinkite storage',
        hint: 'Tik replikuoti telkiniai (erasure coding nepatenka į v1 apimtį). Replikavimas gyvena Ceph: ši lentelė yra MON nuskaitymo stebėta tiesa.',
        createTitle: 'Kurti telkinį',
        createHint: 'Telkinys gimsta klasteryje su prašoma replikacija ir įjungta rbd application — darbą atlieka task MON mazge. Įjunkite „Siūlyti kaip storage“, kad iškart tuo pačiu veiksmu jį panaudotumėte.',
        name: 'Telkinio pavadinimas',
        nameHint: 'DNS-safe (mažosios raidės, skaitmenys, brūkšneliai).',
        size: 'Replikos (size)',
        sizeHint: 'Kiekvieno objekto kopijos. Numatyta 3.',
        minSize: 'Mažiausiai replikų (min_size)',
        minSizeHint: 'Mažiausiai kopijų, kad būtų aptarnaujamas I/O — kol nepakeisite, seka size − 1.',
        createError: 'Telkinio kūrimas buvo atmestas',
        deleteTitle: 'Ištrinti telkinį',
        deleteBody: 'Telkinys {pool} ir KIEKVIENAS jame esantis objektas negrįžtamai sunaikinami. Norėdami patvirtinti, įveskite telkinio pavadinimą.',
        confirmLabel: 'Telkinio pavadinimas',
        confirmHint: 'Norėdami patvirtinti, įveskite telkinio pavadinimą',
        deleteError: 'Telkinio ištrynimas buvo atmestas',
        detailTitle: 'Telkinio detalės',
        autoscaler: 'PG Autoscaler',
        autoscalerOn: 'Aktyvus',
        autoscalerOff: 'Neaktyvus',
        autoscalerWarn: 'Pranešimas',
        pgNumLabel: 'PG skaičius',
        pgNumCaption: 'Stebima reikšmė: autoscaler gali ją keisti savarankiškai — šis laukas įrašo pageidavimą.',
        storage: 'Susietas TVirt storage',
        addAsStorage: 'Pridėti kaip TVirt storage',
        ruleSudoHint: 'CRUSH taisyklės keitimui reikia operatoriaus slaptažodžio.',
        updateError: 'Telkinio keitimas buvo atmestas',
        updated: 'Telkinio keitimas pradėtas — stebėjimo duomenys atsinaujins patys'
      },
      crush: {
        section: 'CRUSH taisyklės',
        notObserved: 'CRUSH stebėjimo duomenų dar nėra — MON nuskaitymas praneš čia',
        empty: 'Klasteryje nestebėta nė vienos taisyklės',
        hint: 'Taisyklė sprendžia, KUR atsiduria kiekvieno objekto kopijos — jos gedimų sritis yra vienetas, kuris gali sugesti neprarandant duomenų. Telkiniai rodo į taisyklę; įtaisytoji replicated_rule (po vieną repliką kiekviename serveryje) yra numatytoji nuo gimimo.',
        create: 'Kurti taisyklę',
        createGuard: 'CRUSH taisyklės egzistuoja tik įdiegtame klasteryje',
        createTitle: 'Kurti CRUSH taisyklę',
        createHint: 'Taisyklė = gedimų srities pasirinkimas. Taisyklė gimsta replikuota numatytajame root — darbą atlieka task MON mazge; telkinius susiekite paskui kortelėje Telkiniai.',
        createError: 'Taisyklės kūrimas buvo atmestas',
        name: 'Taisyklės pavadinimas',
        nameHint: 'DNS-safe (mažosios raidės, skaitmenys, brūkšneliai).',
        domain: 'Gedimų sritis',
        domainChoice: {
          osd: 'Kiekviena replika kitame OSD',
          host: 'Kiekviena replika kitame serveryje',
          rack: 'Kiekviena replika kitame rack'
        },
        domainCustom: 'Pasirinktinė (rankiniu būdu parašyti step)',
        domainOther: 'Kiekviena replika kitame {type}',
        rackGuardHint: 'Stebimoje hierarchijoje nėra nė vieno rack bucket: taisyklę vis tiek galima sukurti, bet nė vienas telkinys negalės į ją rodyti, kol rack nebus deklaruotas serverių narių išdėstyme (mazgo nustatymai) — suderinimo task sukuria bucket ir susiejimas atsiveria pats.',
        treeTitle: 'Stebima hierarchija',
        treeNotObserved: 'Hierarchijos stebėjimo duomenų nėra — MON nuskaitymas praneš čia',
        treeOsds: 'OSD: {n}',
        treeHint: 'CRUSH žemėlapis toks, kokį jį mato klasteris: root → deklaruoti lygiai → serveriai (host) → OSD. Topologija seka kiekvieno serverio deklaruotą išdėstymą (mazgo nustatymai) — pakeitus poziciją, ji suderinama per task.',
        unplacedWarning: 'Nariai be deklaruotos pozicijos: {nodes} — jų hostai lieka tiesiai po root, už deklaruotos topologijos ribų. Deklaruokite poziciją mazgo nustatymuose (tai įspėjimas, niekada ne kliūtis).',
        colName: 'Pavadinimas',
        colDomain: 'Gedimų sritis',
        colPools: 'Telkiniai',
        builtinChip: 'builtin',
        builtinGuard: 'Numatytoji klasterio taisyklė — platforma jos niekada netrina',
        detailAction: 'Taisyklės detalės',
        detailType: 'Tipas',
        backToRules: 'Taisyklės',
        ruleNotObserved: 'Stebimame taisyklių sąraše šios taisyklės nėra',
        noPools: 'Šia taisykle nesinaudoja nė vienas telkinys',
        delete: 'Ištrinti taisyklę',
        deleteTitle: 'Ištrinti CRUSH taisyklę',
        deleteBody: 'Taisyklė {rule} pašalinama iš klasterio crushmap. Ja neturi naudotis nė vienas telkinys. Norėdami patvirtinti, įveskite taisyklės pavadinimą.',
        deleteGuard: 'Ja naudojasi telkinys {name} — pirma nukreipkite telkinį kitur',
        confirmLabel: 'Taisyklės pavadinimas',
        confirmHint: 'Norėdami patvirtinti, įveskite taisyklės pavadinimą',
        deleteError: 'Taisyklės ištrynimas buvo atmestas',
        changeRule: 'Keisti CRUSH taisyklę',
        changeRuleTitle: 'Keisti CRUSH taisyklę',
        changeRuleHint: 'Telkinys ima dėlioti savo objektus pagal pasirinktą taisyklę — Ceph perkelia esamus duomenis, kad jie ją atitiktų (pilname telkinyje seka perbalansavimas).',
        changeRuleError: 'Taisyklės keitimas buvo atmestas',
        rule: 'CRUSH taisyklė',
        rawTitle: 'Neapdorota crushmap (dekompiliuota)',
        rawWarning: 'PAVOJUS: šis tekstas yra VISA klasterio išdėstymo politika. Klaidingas žemėlapis gali iš karto sugriauti visų telkinių placement. Įrašant žemėlapis kompiliuojamas ir išbandomas su crushtool PRIEŠ jį įterpiant — bet ir galiojantis žemėlapis gali būti bloga mintis.',
        rawReload: 'Įkelti iš naujo',
        rawLoading: 'Užklausa vykdoma — tik skaitymo task dekompiliuoja crushmap…',
        rawSave: 'Įrašyti crushmap',
        rawSaveTitle: 'Įterpti crushmap',
        rawSaveBody: 'Pakeistas tekstas pakeičia VISO klasterio crushmap po crushtool kompiliavimo ir bandymo. Norėdami patvirtinti, įveskite klasterio pavadinimą.',
        rawConfirmLabel: 'Klasterio pavadinimas',
        rawConfirmHint: 'Norėdami patvirtinti, įveskite {name}',
        rawError: 'Crushmap operacija nepavyko',
        rawHint: 'Tekstas yra crushtool -d forma. Kompiliavimo ir bandymo klaidos grįžta pažodžiui iš crushtool — jei nepavyksta bent vienas iš dviejų vartų, žemėlapis klasterio nepasiekia.'
      },
      objects: {
        poolsSection: 'Objektų naršyklė',
        poolsHint: 'Pasirinkite telkinį, kad išvardytumėte jo RBD atvaizdžius. Kiekvienas gilus skaitymas vykdomas kaip tik skaitymo task MON mazge — jis neblokuoja tikrų operacijų (ir jos jo neblokuoja).',
        deployedGuard: 'Objektų užklausos atsako tik įdiegtame klasteryje',
        browse: 'Naršyti objektus',
        detailAction: 'Atvaizdžio detalės',
        backToPools: 'Telkiniai',
        backToImages: 'Atvaizdžiai',
        refresh: 'Atnaujinti',
        loading: 'Užklausa vykdoma — tik skaitymo task klausinėja klasterį…',
        error: 'Užklausa nepavyko',
        retry: 'Bandyti dar kartą',
        notRbd: 'Telkinys su application „{app}“ — jame nėra RBD atvaizdžių, čia nėra ko naršyti',
        noImages: 'Šiame telkinyje RBD atvaizdžių nėra',
        colImage: 'Atvaizdis',
        colSize: 'Dydis',
        colObjects: 'Objektai',
        colSnapshots: 'Snapshot',
        imagesHint: 'Diskai naudojančiame rbd storage yra atvaizdžiai, pavadinti savo disko id vardu. Objektų skaičius yra priskirtas (dydis / objekto dydis) — tikrasis užimtumas gyvena atvaizdžio detalėse.',
        infoTitle: 'Atvaizdis',
        infoSize: 'Virtualus dydis',
        infoObjects: 'Objektai (priskirti)',
        infoObjectSize: 'Objekto dydis',
        infoPrefix: 'Objektų priešdėlis',
        infoFormat: 'Formatas',
        infoFeatures: 'Savybės',
        usageTitle: 'Tikras užimtumas (rbd du)',
        usageOf: 'iš {provisioned} GiB priskirtų',
        usageHint: 'Thin iš prigimties: baitus užima tik įrašyti objektai.',
        watchersTitle: 'Watcher',
        noWatchers: 'Watcher nėra — šio atvaizdžio dabar niekas nelaiko atverto',
        snapshotsTitle: 'RBD snapshot',
        noSnapshots: 'Šiame atvaizdyje RBD snapshot nėra',
        colSnapshot: 'Snapshot',
        colProtected: 'Apsaugotas',
        colTimestamp: 'Sukurta',
        protected: 'apsaugotas',
        mappingTitle: 'Fizinis atvaizdavimas (OSD aibė)',
        mappingSampled: 'Imtis: {sampled} objektai iš {total} — sąžininga santrauka: dideliems atvaizdžiams aibė suartėja su VISAIS telkinio OSD (CRUSH paskirsto objektus po visą telkinį).',
        mappingComplete: 'Visi objektai atvaizduoti ({total} iš {total}).',
        objectQueryTitle: 'Atvaizduoti vieną objektą',
        objectName: 'Objekto vardas',
        objectHint: 'RADOS objektų vardai yra <priešdėlis>.<16-hex indeksas> — ceph osd map atsako PG ir OSD trejetais.',
        mapObject: 'Atvaizduoti',
        primary: 'pirminis: osd.{osd}'
      },
      registerDevice: {
        title: 'Registruoti OSD įrenginį',
        hint: 'Gyvame klasteryje registracija įrenginį taip pat PARUOŠIA: jis tampa BlueStore OSD su automatiniu mazgui pririštu task (niekada tuščias, ratifikuota 2026-07-24). Įrenginys priklauso daugiausia vienam Ceph klasteriui visame parke.',
        disk: 'Duomenų diskas',
        diskHint: 'Deklaruoti mazgo duomenų diskai — pavadinimas ir serijos numeris',
        noDeclared: 'Šiame mazge nedeklaruotas nė vienas duomenų diskas — pirma pažymėkite juos vietiniuose mazgo nustatymuose',
        serialHint: 'Įrenginio serijos numeris — tapatybės prisegimas',
        encrypted: 'Šifruoti šį OSD (dmcrypt)',
        encryptedHint: 'Pasirinkimas kiekvienam OSD atskirai (klasterio režimas yra „pasirenkama kiekvienam OSD“): registruojant jis užšaldomas šiame diske — vėlesnis režimo keitimas jo niekada neperrašo; tai daro eilutės veiksmas šifruoti arba iššifruoti.',
        error: 'Registracija buvo atmesta'
      },
      unregisterDevice: {
        title: 'Išregistruoti įrenginį',
        body: 'Tik registras: {name} nustoja būti šio klasterio OSD kandidatu. Jo baitai neliečiami.',
        error: 'Išregistravimas buvo atmestas'
      },
      deploy: {
        action: 'Bandyti diegti iš naujo',
        title: 'Bandyti bootstrap iš naujo',
        body: 'Gimimo bootstrap prasideda iš naujo nuo dabartinės konfigūracijos: mon paleidžiami, o kiekvienas užregistruotas įrenginys paruošiamas ir aktyvuojamas kaip BlueStore OSD. Operacija vykdoma kaip makrotask — fazė atsinaujins pati.',
        started: 'Bootstrap pradėtas — tęsiamas kaip makrotask; fazė atsinaujins pati',
        error: 'Bootstrap buvo atmestas'
      },
      propose: {
        action: 'Siūlyti kaip storage',
        title: 'Siūlyti kaip storage',
        hintPool: 'Esamas telkinys {name} tampa TVirt storage: telkiniu apribota cephx tapatybė patenka į keystore, o ceph-rbd storage gimsta parengtas. Pasiūlymas telkinį naudoja — niekada jo nekuria.',
        hintFs: 'Esama failų sistema {name} tampa TVirt storage: failų sistema apribota cephx tapatybė patenka į keystore, o cephfs storage gimsta parengtas ir prijungtas. Pasiūlymas failų sistemą naudoja — niekada jos nekuria.',
        name: 'Storage pavadinimas',
        nameHint: 'DNS-1123, unikalus scope viduje — cephx tapatybė vardą gauna iš jo.',
        path: 'Kelias failų sistemos viduje',
        pathHint: 'Absoliutus kelias failų sistemoje, kurį prijungia šis storage — abejojant /.',
        alsoPropose: 'Iškart siūlyti kaip storage',
        alsoProposePoolHint: 'Po sukūrimo tas pats veiksmas pasiūlo ką tik gimusį telkinį kaip ceph-rbd storage — du aiškūs iškvietimai, vienas dialogas.',
        alsoProposeFsHint: 'Po sukūrimo tas pats veiksmas pasiūlo ką tik gimusią failų sistemą kaip cephfs storage — du aiškūs iškvietimai, vienas dialogas.',
        guard: 'Siūlyti kaip storage — tik sveikame klasteryje',
        started: 'Pasiūlymas priimtas — storage materializuojasi; rasite jį skiltyje Storage',
        submit: 'Kurti storage',
        error: 'Pasiūlymas buvo atmestas'
      },
      fs: {
        section: 'Failų sistemos',
        create: 'Kurti failų sistemą',
        createGuard: 'Failų sistemos egzistuoja tik įdiegtame klasteryje',
        mdsFirstGuard: 'Pirma pridėkite MDS — failų sistema be metaduomenų serverio gimsta netinkama naudoti',
        notObserved: 'Failų sistemų stebėjimo duomenų nėra — MON nuskaitymas praneš čia',
        empty: 'Klasteryje failų sistemų nėra',
        colName: 'Pavadinimas',
        colPools: 'Telkiniai',
        colMds: 'MDS',
        noActiveMds: 'nėra aktyvaus MDS',
        delete: 'Šalinti failų sistemą',
        deleteGuard: 'Naudoja storage {name} — pirma ištrinkite storage',
        hint: 'Failų sistema turi savo duomenų ir metaduomenų telkinius (cephfs.<vardas>.data / .meta): jie gimsta ir miršta kartu su ja — removeFs, o ne rankinis telkinio trynimas. Ši lentelė yra MON nuskaitymo stebėta tiesa.',
        createTitle: 'Kurti failų sistemą',
        createHint: 'Failų sistema gimsta klasteryje su savo dviem telkiniais (application cephfs) ir yra aptarnaujama deklaruotų MDS — darbą atlieka task MON mazge. Įjunkite „Siūlyti kaip storage“, kad iškart tuo pačiu veiksmu ją panaudotumėte.',
        name: 'Failų sistemos pavadinimas',
        nameHint: 'DNS-safe (mažosios raidės, skaitmenys, brūkšneliai).',
        sizeHint: 'ABIEJŲ gimstančių telkinių replikos. Numatyta 3.',
        createError: 'Failų sistemos kūrimas buvo atmestas',
        deleteTitle: 'Šalinti failų sistemą',
        deleteBody: 'Failų sistema {fs} ir KIEKVIENAS joje esantis failas negrįžtamai sunaikinami — jos duomenų ir metaduomenų telkiniai miršta kartu su ja. Norėdami patvirtinti, įveskite failų sistemos pavadinimą.',
        confirmLabel: 'Failų sistemos pavadinimas',
        confirmHint: 'Norėdami patvirtinti, įveskite failų sistemos pavadinimą',
        deleteError: 'Failų sistemos šalinimas buvo atmestas'
      },
      destroy: {
        action: 'Sunaikinti',
        retryAction: 'Bandyti ištrinti dar kartą',
        retryGuard: 'Naikinimas vykdomas — kartojimas skirtas nepavykusiam naikinimui (kitaip lease atmeta)',
        title: 'Sunaikinti klasterį',
        body: 'Įdiegtas fabric išmontuojamas: kiekvienas šio klasterio demonas sustabdomas, o jo sisteminė būsena ir raktai keystore atlaisvinami. Sėkmingai sunaikinus, klasteris pašalinamas automatiškai.',
        confirmLabel: 'Klasterio pavadinimas',
        confirmHint: 'Norėdami patvirtinti, įveskite klasterio pavadinimą',
        wipe: 'Išvalyti užregistruotus įrenginius',
        wipeHint: 'Pažymėta: kiekvieno užregistruoto įrenginio parašai ištrinami — juose esantys duomenys sunaikinami. Nepažymėta: baitai lieka nepaliesti, o įrenginiai grįžta į užregistruotų būseną.',
        guard: 'Sunaikinti — nieko neįdiegta',
        started: 'Naikinimas pradėtas — tęsiamas kaip makrotask; fazė atsinaujins pati',
        error: 'Naikinimas buvo atmestas'
      },
      delete: {
        guard: 'Ištrinti — tik neįdiegtą konfigūraciją (pirma sunaikinkite)',
        title: 'Ištrinti {name}?',
        body: 'Konfigūracija ir jos įrenginių registras pašalinami. Teisėta tik tol, kol niekas neįdiegta.',
        error: 'Ištrynimas buvo atmestas'
      }
    }
  }
}
